<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem>企业查询配置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">企业查询配置</div>
      </div>
    </div>

    <div class="catalogue-content">
      <div style="display: flex">
        <div class="catalogue-content-l">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="200"
            @submit.native.prevent
          >
            <FormItem label="CMEF：" prop="cmefId">
              <Select v-model="formInline.cmefId" filterable style="width: 600px">
                <Option v-for="item in exList" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </FormItem>

            <FormItem label="ICMD：" prop="icmdId">
              <Select v-model="formInline.icmdId" filterable style="width: 600px">
                <Option v-for="item in exList" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </FormItem>

            <FormItem label="康复：" prop="kfId">
              <Select v-model="formInline.kfId" filterable style="width: 600px">
                <Option v-for="item in exList" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </FormItem>

            <FormItem style="padding-top: 20px">
              <Button
                type="primary"
                size="large"
                @click="handleSubmit('formInline')"
                style="width: 154px"
                >保存</Button
              >
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-catalogue",
  data() {
    return {
      exList: [],
      exNameValue: [],
      agentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",

      formInline: {
        cmefId: "",
        icmdId: "",
        kfId: "",
      },
      ruleInline: {
        cmefId: [{ required: true, message: "请选择展会", trigger: "blur" }],
        icmdId: [{ required: true, message: "请选择展会", trigger: "blur" }],
        kfId: [{ required: true, message: "请选择展会", trigger: "blur" }],
      },
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
    }),
    exhibitionId() {
      return this.exhibition.id;
    },
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 企业查询配置";
    this.init();
  },
  methods: {
    ...mapActions({
      getExByAgentId: "hostSetModule/getExByAgentId",
      getAllExhibitionsApplyCompany: "hostSetModule/getAllExhibitionsApplyCompany",
      applyCompanyUpdateExhibitionName: "hostSetModule/applyCompanyUpdateExhibitionName",
    }),
    async init() {
      let res = await this.getExByAgentId({
        AgentId: this.agentId,
        pageSize: 1000,
      });
      if (res && res.items.length > 0) {
        this.exList = res.items;
        console.log(this.exList);
        this.getExNameValue();
      }
    },
    async getExNameValue() {
      let res = await this.getAllExhibitionsApplyCompany();
      if (res.data && res.data.length > 0) {
       res.data.forEach((item) => {
         if(item.name=="CMEF"){
            this.formInline.cmefId = item.value;
         }else if(item.name=="ICMD"){
            this.formInline.icmdId = item.value;
         }else if(item.name=="CRS"){
            this.formInline.kfId = item.value;
         }
       });
      }
      console.log(this.formInline,'0000');
    },

    async handleSubmit(name) {
      console.log(this.formInline);
      let valid = await this.validForm(name);
      if (valid) {
        let opt = [{
            value: this.formInline.cmefId,
            name: "CMEF",
        },{
            value: this.formInline.icmdId,
            name: "ICMD",
        },{
            value: this.formInline.kfId,
            name: "CRS",
        }]
        let data1 = await this.applyCompanyUpdateExhibitionName(opt);
          this.$Message.success("修改成功 ");
          this.init()
      }
    },

    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.intTextarea {
  .ivu-form-item-error-tip {
    top: 75%;
  }
}
.no-label {
  .ivu-form-item-label:before {
    opacity: 0 !important;
  }
}
</style>
<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1400px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    .catalogue-tip {
      color: #ff0000;
      padding: 0 0 5px 200px;
      .txt {
        padding-left: 10px;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
    &-l {
      width: 50%;
      min-width: 700px;
    }
    &-r {
      display: flex;
      // min-width: 700px;
      .logo-example {
        display: flex;
        &-box {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
        }
        &-item {
          display: flex;
          width: 100%;
          p {
            font-size: 12px;
            color: #808080;
            padding-left: 10px;
          }
          &.z-large-s {
            img {
              width: 40px;
              height: 40px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 40px;
            }
          }
          &.z-large-m {
            img {
              width: 30px;
              height: 30px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 30px;
            }
          }
          &.z-large-l {
            img {
              width: 20px;
              height: 20px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .mask {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
